// Generated by CoffeeScript 1.6.3
(function() {
  rjm.model.Chart = Backbone.RelationalModel.extend({
    initialize: function(options) {
      if (!options || !options.hasOwnProperty("clientId") || !options.hasOwnProperty("series") || !options.hasOwnProperty("dataLimit") || !options.hasOwnProperty("timeFrame") || !options.hasOwnProperty("timeInterval") || !options.hasOwnProperty("chartStyle")) {
        throw "InvalidConstructorArgs - Chart";
      }
      _.bindAll(this, "url", "bindEnums", "toJSON", "getNumberOfDataPoints", "getValidPerspectives", "isCohortChart", "hasTimestamp");
      this.clientId = options.clientId;
      this.id = options.id;
      this.bindEnums();
      if (this.isCohortChart()) {
        this.listenToCohortEvents();
      }
    },
    bindEnums: function() {
      this.set({
        timeInterval: rjm.app.enums.timeInterval[this.get("timeInterval")],
        chartStyle: rjm.app.enums.chartStyle[this.get("chartStyle")]
      });
    },
    listenToCohortEvents: function() {
      var _this = this;
      this.listenTo(this, "change:timeInterval", function(e, obj) {
        if (obj != null) {
          return _this.getCurrentSeries().get('cohortDescriptor').set({
            timeInterval: obj.serializedValue
          });
        }
      });
    },
    unbindEnumsFromAttributes: function(attributes) {
      attributes.chartStyle = attributes.chartStyle.serializedValue;
      if (attributes.timeInterval) {
        attributes.timeInterval = attributes.timeInterval.serializedValue;
      } else {
        attributes.timeInterval = false;
      }
      return attributes;
    },
    relations: [
      {
        type: Backbone.HasMany,
        key: "series",
        relatedModel: "rjm.model.Series",
        collectionType: "rjm.model.SeriesList",
        includeInJSON: true
      }, {
        type: Backbone.HasOne,
        key: "dataLimit",
        relatedModel: "rjm.model.DataLimit",
        includeInJSON: true
      }, {
        type: Backbone.HasOne,
        key: "timeFrame",
        relatedModel: "rjm.model.TimeFrame",
        includeInJSON: true
      }
    ],
    url: function() {
      if (!this.id) {
        if (!this.get("dashboardId")) {
          return $.url("/client/" + this.clientId + "/chart/create");
        } else {
          return $.url("/client/" + this.clientId + "/chart/create?did=" + this.get("dashboardId"));
        }
      }
      return $.url("/client/" + this.clientId + "/chart/" + this.id);
    },
    toJSON: function() {
      var r;
      r = void 0;
      r = Backbone.RelationalModel.prototype.toJSON.call(this);
      r = this.unbindEnumsFromAttributes(r);
      return r;
    },
    isScalar: function() {
      return !this.get("isTimeOnXAxis") && !this.getCurrentSeries().get("categorySet").hasSelectors();
    },
    getNumberOfDataPoints: function() {
      var numberOfSecondsInRange;
      numberOfSecondsInRange = this.get("timeFrame").getNumberOfSecondsInRange(this.getCurrentSeries().get("trend").get("minTime"));
      if (_(numberOfSecondsInRange).isNull()) {
        return {};
      }
      return {
        HOUR: Math.ceil(numberOfSecondsInRange / rjm.app.enums.timeInterval.HOUR.secondsInInterval),
        DAY: Math.ceil(numberOfSecondsInRange / rjm.app.enums.timeInterval.DAY.secondsInInterval),
        WEEK: Math.ceil(numberOfSecondsInRange / rjm.app.enums.timeInterval.WEEK.secondsInInterval),
        MONTH: Math.ceil(numberOfSecondsInRange / rjm.app.enums.timeInterval.MONTH.secondsInInterval),
        QUARTER: Math.ceil(numberOfSecondsInRange / rjm.app.enums.timeInterval.QUARTER.secondsInInterval),
        YEAR: Math.ceil(numberOfSecondsInRange / rjm.app.enums.timeInterval.YEAR.secondsInInterval)
      };
    },
    getValidPerspectives: function() {
      var obj, validKeys, _ref;
      obj = void 0;
      validKeys = void 0;
      validKeys = ["STANDARD", "CUMULATIVE", "PERCENT_FIRST", "PERCENT_FIRST_NOSHOW"];
      if (!this.isCohortChart() && !this.hasMultipleGroupings()) {
        validKeys.push("POP_PERCENT");
        validKeys.push("POP_AMOUNT");
        validKeys.push("YOY_PERCENT");
        validKeys.push("YOY_AMOUNT");
      }
      if (this.isRepeatEventPerspectiveValid()) {
        validKeys.push('INC_EVENT_PROB');
      } else if (this.getCurrentSeries().get('dataPerspective') === rjm.app.enums.dataPerspective.INC_EVENT_PROB) {
        this.getCurrentSeries().set({
          dataPerspective: rjm.app.enums.dataPerspective.STANDARD
        });
      }
      if (this.isCohortChart() && ((_ref = this.getCurrentSeries().get("cohortDescriptor").get("cohortField")) != null ? _ref.get("canCountMembers") : void 0)) {
        validKeys.push("PER_COHORT_MEMBER");
        validKeys.push("CUMULATIVE_PER_COHORT_MEMBER");
      }
      obj = {};
      _(validKeys).each(function(x) {
        return obj[x] = rjm.app.enums.dataPerspective[x];
      });
      return obj;
    },
    hasMultipleGroupings: function() {
      return this.getCurrentSeries().get('categorySet').get('categorySelectors').length > 1;
    },
    isRepeatEventPerspectiveValid: function() {
      var categorySelectors, command, restr, restrictions, restrictionsOk, _i, _len, _ref;
      if (this.get('isTimeOnXAxis') || this.get('timeFrame').get('type') !== rjm.app.enums.timeFrameType.ALL_TIME) {
        return false;
      }
      command = this.getCurrentSeries().get('trend').get('command');
      categorySelectors = this.getCurrentSeries().get('categorySet').get('categorySelectors');
      restrictions = this.getCurrentSeries().get('restrictionSet').get('restrictions');
      if (command === rjm.app.enums.aggregateFunction.COUNT.serializedValue || command === rjm.app.enums.aggregateFunction.SUM.serializedValue || command === rjm.app.enums.aggregateFunction.COUNT_DISTINCT.serializedValue) {
        if (categorySelectors.size() === 1 && rjm.app.enums.derivativeType[categorySelectors.at(0).get('column').get('derivativeType')] === rjm.app.enums.derivativeType.EVENT_NUMBER) {
          if (restrictions.size() > 0) {
            restrictionsOk = true;
            _ref = restrictions.toArray();
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              restr = _ref[_i];
              if (!restrictionsOk) {
                return false;
              }
              restrictionsOk = this.isValidRepeatEventFilter(restr.get('left').get('sid'), categorySelectors.at(0).get('column').get('sid'));
            }
            return restrictionsOk;
          } else {
            return true;
          }
        }
      }
      return false;
    },
    isValidRepeatEventFilter: function(filterSid, grouperSid) {
      var currColumn, currColumnSid, firstRef, goodec, grouper, grouperOwnerColumnSid, kc, meta, _i, _len, _ref;
      if (filterSid === grouperSid) {
        return true;
      }
      grouper = rjm.app.localStructure[grouperSid];
      grouperOwnerColumnSid = grouper.meta.ownerColumn;
      if (filterSid === grouperOwnerColumnSid) {
        return true;
      }
      currColumnSid = filterSid;
      while (currColumnSid) {
        currColumn = rjm.app.localStructure[currColumnSid];
        if (rjm.app.enums.derivativeType[currColumn.derivative] === rjm.app.enums.derivativeType.RELOCATED_FIELD) {
          meta = currColumn.meta;
          firstRef = meta.relocationPath[0].sid;
          if (firstRef === grouperOwnerColumnSid) {
            return true;
          }
          currColumnSid = firstRef;
        } else if (currColumn.derivative != null) {
          meta = currColumn.meta;
          currColumnSid = meta.sourceColumn;
          if (rjm.app.enums.derivativeType[currColumn.derivative] === rjm.app.enums.derivativeType.CALCULATION && meta.sourceColumns.length === 1) {
            currColumnSid = meta.sourceColumns[0];
          }
          goodec = false;
          if (rjm.app.enums.derivativeType[currColumn.derivative] === rjm.app.enums.derivativeType.EVENT_COUNTER) {
            if ($.isArray(meta.keyColumns)) {
              _ref = meta.keyColumns;
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                kc = _ref[_i];
                if (kc.local === grouperOwnerColumnSid) {
                  goodec = true;
                }
              }
            }
          }
          if (meta.sourceColumn === grouperOwnerColumnSid || goodec) {
            if (rjm.app.enums.derivativeType[currColumn.derivative] === rjm.app.enums.derivativeType.EVENT_NUMBER) {
              return false;
            }
            if (rjm.app.enums.derivativeType[currColumn.derivative] === rjm.app.enums.derivativeType.CALCULATION || rjm.app.enums.derivativeType[currColumn.derivative] === rjm.app.enums.derivativeType.DATE_DIFF || rjm.app.enums.derivativeType[currColumn.derivative] === rjm.app.enums.derivativeType.SEQUENTIAL_COMPARISON || rjm.app.enums.derivativeType[currColumn.derivative] === rjm.app.enums.derivativeType.SEQUENTIAL_COMPARISON || rjm.app.enums.derivativeType[currColumn.derivative] === rjm.app.enums.derivativeType.SUBSCRIPTION_ID) {
              return false;
            }
            return true;
          }
        } else {
          currColumnSid = false;
        }
      }
      return false;
    },
    isCohortChart: function() {
      if (this.getCurrentSeries().get('cohortDescriptor') != null) {
        return true;
      }
      return false;
    },
    hasTimestamp: function() {
      var _ref;
      return this.isGAChart() || ((_ref = this.getCurrentSeries().get("trend")) != null ? _ref.hasTimestamp() : void 0);
    },
    isGAChart: function() {
      return this.get('api_conn_id') != null;
    },
    getCurrentSeries: function() {
      return this.get("series").at(0);
    },
    setGAConnection: function(GAConnection) {
      this.set({
        api_conn_id: GAConnection
      });
      this.getCurrentSeries().set({
        trend: null
      }, {
        silent: true
      });
      return this.trigger("standard");
    },
    changeTrend: function(newTrend) {
      var previousTrend;
      if (!newTrend.hasTimestamp()) {
        this.set({
          isTimeOnXAxis: false
        }, {
          silent: true
        });
        this.get("timeFrame").set({
          type: rjm.app.enums.timeFrameType.ALL_TIME
        }, {
          silent: true
        });
        this.unset("timeInterval", {
          silent: true
        });
      } else if (this.isCohortChart()) {
        this.get("timeFrame").set({
          type: rjm.app.enums.timeFrameType.ALL_TIME
        }, {
          silent: true
        });
        this.get("dataLimit").set({
          size: 100,
          units: rjm.app.enums.dataLimitUnit.PERCENT
        }, {
          silent: true
        });
        this.stopListening(this, "change:timeInterval");
      }
      if (!newTrend.isGATrend()) {
        this.set({
          api_conn_id: null
        });
      }
      this.stopListening(this, "change:timeInterval");
      this.trigger("standard");
      previousTrend = this.getCurrentSeries().previous("trend");
      this.getCurrentSeries().set({
        trend: newTrend,
        dataPerspective: rjm.app.enums.dataPerspective.STANDARD,
        cohortDescriptor: null
      });
      if (previousTrend === newTrend) {
        this.getCurrentSeries().trigger("change:trend", this.getCurrentSeries());
        this.trigger("change", this, {
          force: true
        });
      }
    },
    cohortMode: function() {
      var newCohortDescriptor;
      if (this.get("timeInterval") === null || this.get("timeInterval") === void 0 || this.get("timeInterval") === rjm.app.enums.timeInterval.HOUR) {
        this.set({
          timeInterval: rjm.app.enums.timeInterval.MONTH
        }, {
          silent: true
        });
      }
      newCohortDescriptor = new rjm.model.CohortDescriptor({
        timeInterval: this.get("timeInterval").serializedValue
      });
      if (this.get("chartStyle") === rjm.app.enums.chartStyle.SCALAR || this.get("chartStyle") === rjm.app.enums.chartStyle.PIE_CHART) {
        this.set({
          chartStyle: rjm.app.enums.chartStyle.LINE_CHART
        }, {
          silent: true
        });
      }
      this.get("dataLimit").set({
        size: 12,
        units: rjm.app.enums.dataLimitUnit.NOMINAL
      }, {
        silent: true
      });
      this.getCurrentSeries().set({
        cohortDescriptor: newCohortDescriptor,
        dataPerspective: rjm.app.enums.dataPerspective.STANDARD
      }, {
        silent: true
      });
      this.set({
        isTimeOnXAxis: true
      }, {
        silent: true
      });
      this.listenToCohortEvents();
      this.getCurrentSeries().get("categorySet").removeAllCategories({
        silent: true
      });
      return this.trigger("cohort");
    },
    removeCohort: function() {
      this.get("timeFrame").set({
        type: rjm.app.enums.timeFrameType.ALL_TIME
      }, {
        silent: true
      });
      this.get("dataLimit").set({
        size: 100,
        units: rjm.app.enums.dataLimitUnit.PERCENT
      }, {
        silent: true
      });
      this.getCurrentSeries().set({
        cohortDescriptor: null,
        dataPerspective: rjm.app.enums.dataPerspective.STANDARD
      });
      this.stopListening(this, "change:timeInterval");
      return this.trigger("standard");
    }
  });

}).call(this);
